import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(items: any, sortKey, sortOrder?): any {
    if (!items) {
      return [];
    } else if (!sortKey) {
        return items;
    } else {
       const emptyResults = [];
       const nonemptyResults = [];
       items.forEach((i) => {
            if (i[sortKey]) {
              nonemptyResults.push(i);
            } else {
              emptyResults.push(i);
            }
       });
       let sortResults = nonemptyResults.sort((a: any, b: any) => {
        if (!(isNaN(a[sortKey]) && !isNaN(Date.parse(a[sortKey])))) {
            // string /number type sorting
             if (typeof a[sortKey] === 'string') {
              const fieldA = a[sortKey].toLowerCase();
              const  fieldB = b[sortKey].toLowerCase();
              if (sortOrder) {
                return fieldA !== fieldB ? fieldA < fieldB ? -1 : 1 : 0;
              } else {
                return fieldA !== fieldB ? fieldA > fieldB ? -1 : 1 : 0;
              }
            } else {
              if (sortOrder) {
                return a[sortKey] - b[sortKey];
              } else {
                return b[sortKey] - a[sortKey];
              }
            }
        } else {
          // date sorting
            const date1: any = new Date(a[sortKey]);
            const date2: any = new Date(b[sortKey]);
            if (sortOrder) {
              return date1 -  date2;
            } else {
              return date2 - date1;
            }
        }
      });
       if (sortOrder) {
         sortResults = [...emptyResults, ...sortResults];
       } else {
         sortResults = [...sortResults, ...emptyResults];
       }
       return sortResults;
    }
  }

}
